module.exports = __webpack_public_path__ + "img/espy-analytics-short-dark-bg.0d8f20c3.svg";